import { TrackerContext } from '@contexts';
import { useContext } from 'react';

export function useTracker() {
  const context = useContext(TrackerContext);
  if (context === undefined) {
    throw new Error('useTracker must be used within a TrackerContextProvider');
  }
  return context;
}
